import BurgerAccordion from "./components/burger-accordion";
import BurgerMenu from "./components/burger-menu";
import HeaderScroll from "./components/header-scroll";
import NavigationMenu from "./components/navigation-menu";
import ToUpBtn from "./components/to-up-btn";
import SearchMenu from "./components/search-menu";
import LazyVideo from "./components/lazy-video";
// import ProductCardSlider from "./components/product-card-slider";
import Footer from "./components/footer";
import ProductRadioBtn from "./components/product-radio-btn";
import SubscribeForm from "./components/subscribe-form";
import Selects from "./components/selects";
import ProductCardOptions from "./components/product-card-options";
import Filter from "./components/filter";
// import Wishlist from "./components/wishlist";
// import WishlistModals from "./components/wishlist-modals";
// import UndoPopUp from "./components/undo-pop-up";
import TextCollapsed from "./components/text-collapsed";
import MukhiSlider from "./components/mukhi-slider";
import Tabs from "./components/tabs";
import Accordion from "./components/accordion";
import CardsSliderFixThree from "./components/sliders/cards-slider-fix-three";
import ProductsSliderFixFour from "./components/sliders/products-slider-fix-four";
import CardsSliderAutoThree from "./components/sliders/cards-slider-auto-three";
import CardsSliderAutoFour from "./components/sliders/cards-slider-auto-four";
import ProductMainSlider from "./components/product-main-slider";
window.ProductMainSlider = ProductMainSlider;
import QtyInput from "./components/qty-input";
import FixedBlockProduct from "./components/fixed-block-product";
import SizeGuide from "./components/size-guide";
import ScrollToAnchor from "./components/scroll-to-anchor";
import TogglePassword from "./components/toggle-password";
import DatePicker from "./components/date-picker";
import AuthTextCollapsed from "./components/auth-text-collapsed";
import Filters from "./components/filters";
import ArticleContents from "./components/article-contents";
import ArticleLeaveComment from "./components/article-leave-comment";
import Header from "./components/header";
import FaqsTabs from "./components/faqs-tabs";
import RegisterBirthDate from "./components/register-birth-date";
import BirthTimeMask from "./components/birth-time-mask";
import PhoneMask from "./components/phone-mask";
import WholesaleForm from "./components/wholesale-form";
import ReviewVideo from "./components/review-video";
import ReviewsCategory from "./components/reviews-category";
import ReviewsByProductSlider from "./components/reviews-by-product-slider";
import PeriodDatePicker from "./components/period-date-picker";
import Cart from "./components/cart";
import Contents from "./components/contents";
import Stockists from "./components/stockists";
import Team from "./components/team";
import GallerySlider from "./components/gallery-slider";
import StampedAPI from "./api/stamped-api";
import Fetch from "./api/fetch";

document.addEventListener("DOMContentLoaded", function () {
  Header();
  HeaderScroll();
  NavigationMenu();
  BurgerMenu();
  SearchMenu();
  BurgerAccordion();
  ToUpBtn();
  LazyVideo();
  // ProductCardSlider();
  ProductCardOptions();
  Footer();
  ProductRadioBtn();
  SubscribeForm();
  Selects();
  Filter();
  // Wishlist();
  // WishlistModals();
  // UndoPopUp();
  TextCollapsed();
  MukhiSlider();
  Tabs();
  Accordion();
  // Sliders
  ProductsSliderFixFour();
  CardsSliderFixThree();
  CardsSliderAutoThree();
  CardsSliderAutoFour();
  // Sliders
  ProductMainSlider();
  // QtyInput();
  FixedBlockProduct();
  SizeGuide();
  ScrollToAnchor();
  TogglePassword();
  DatePicker();
  AuthTextCollapsed();
  // Filters();
  ArticleContents();
  ArticleLeaveComment();
  FaqsTabs();
  RegisterBirthDate();
  BirthTimeMask();
  PhoneMask();
  WholesaleForm();
  ReviewVideo();
  ReviewsCategory();
  ReviewsByProductSlider();
  PeriodDatePicker();
  Cart();
  Contents();
  Stockists();
  Team();
  GallerySlider();
  // StampedAPI();
  // Fetch();
});

